import { render } from "./TermsConditionView.vue?vue&type=template&id=0999cc28&scoped=true"
import script from "./TermsConditionView.vue?vue&type=script&lang=js"
export * from "./TermsConditionView.vue?vue&type=script&lang=js"

import "./TermsConditionView.vue?vue&type=style&index=0&id=0999cc28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999cc28"]])

export default __exports__